<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3"
    :class="`${
      isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'
    } ${sidebarType}`"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      <!-- Sidebar Logo: independently styled -->
      <a class="m-0 navbar-brand" href="/dashboard">
        <img
          :src="
            sidebarType === 'bg-white' ||
            (sidebarType === 'bg-transparent' && !isDarkMode)
              ? logoDark
              : logo
          "
          class="sidebar-logo"
          alt="Hend E-Commerce Sidebar Logo"
        />
      </a>
    </div>

    <hr class="horizontal light mt-0 mb-2" />
    <sidenav-list />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/hend_logo.png";
import logoDark from "@/assets/hend_logo.png"; // Replace with actual dark version if needed
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      logoDark,
    };
  },
  computed: {
    ...mapState(["isRTL", "sidebarType", "isDarkMode"]),
  },
};
</script>

<style scoped>
.sidebar-logo {
  height: 90px; /* ⬆️ Increase height as needed */
  object-fit: contain;
  display: block;
  margin: 0 auto;
  margin-top: -22px; /* Adjust vertical spacing */
  padding-bottom: 6px;
}

@media (max-width: 1199.98px) {
  #sidenav-main {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
    border-radius: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 1050;
    background-color: #fff;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
  }

  :global(.g-sidenav-show.g-sidenav-pinned) #sidenav-main {
    transform: translateX(0);
  }

  :global(.g-sidenav-show.g-sidenav-pinned) .main-content {
    pointer-events: none;
  }
}
</style>
